"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/AdminPreview.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Avatar = require('web/components/Avatar');











// The former defaultProps, as shared module values so their identity is the
// same on every render, as it was.
const noAdminEntity = {}
const noop = () => { /* the former default: nothing to do */ }

const AdminPreview = ({
  onRemove = noop,
  isMe = false,
  adminEntity = noAdminEntity,
  orgName = '',
}) => {
  const adminNameClassName = _classBuilder2.default.call(void 0, 
    "meeting--management--admin-name",
    { 'is-me': isMe },
  )

  return (
    _react2.default.createElement('div', { className: "meeting--management--admin", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
      , _react2.default.createElement('div', { className: "meeting--management--admin-avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
        , _react2.default.createElement(_Avatar.EntityAvatar, { entity: adminEntity, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
      )
      , _react2.default.createElement('div', { className: "meeting--management--admin-desc-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
        , _react2.default.createElement('div', { className: "meeting--management--admin-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
          , _react2.default.createElement('span', { className: adminNameClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}},  adminEntity.Name )
          ,  orgName &&
            _react2.default.createElement('span', { className: "meeting--management--admin-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
              ,  orgName 
            )
          
        )
        ,  !isMe &&
          _react2.default.createElement('span', {
            onClick: onRemove,
            className: "meeting--management--admin-remove-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
, "Remove"

          )
        
        , _react2.default.createElement('div', { className: "meeting--management--admin-more-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} )
      )
    )
  )
}

exports. default = AdminPreview
